import GymSvg from "@assets/images/svg/gym.svg";
import React from "react";
import { View } from "react-native";

export interface GymIconProps {
  size?: number;
  color?: string;
}

export function GymIcon({ size = 24, color = "#4D4D4D" }: GymIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <GymSvg width={size} height={size} color={color} />
    </View>
  );
}

export default GymIcon;
